<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="d-flex  m-3 justify-content-between">
        <p class="fw-bold">
          سنجش اثرات/  <span  v-if="status">
          نهاده
        </span>
          <span v-else>
            نماگر
          </span>
        </p>
        <div>
          <div @click.prevent="status=!status"  class="d-flex changer">
            <p  v-if="status">
              نهاده
            </p>
            <p v-else>
              نماگر
            </p>

            <p v-if="status">
              نماگر
            </p>
            <p v-else>
              نهاده
            </p>
          </div>

        </div>
      </div>
      <hr class="mb-2">

     <center>
       <Input v-if="status" class="mt-3"/>
       <Photographer v-else class="mt-3"/>

     </center>





    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import SupportMeasures from "@/components/Definition_of_basic_measures/SupportMeasures.vue";
import Input from "@/components/Impact_Assessment/Input.vue";
import Photographer from "@/components/Impact_Assessment/Photographer.vue";
import router from "@/router";

export default {
  components: {
    Input,
    Photographer,

    Sidebar,
    splash
  },
  data(){
    return{
      status: true,
      id_route: this.$route['params']['id'],
    }
  },
  methods:{
    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
        return
      }

    }
  },
  mounted() {
    this.checkIsMother()
  }

}
</script>
<style scoped lang="scss">
.changer{
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 20vw;
  justify-content: space-evenly;
  &>p:nth-child(1){
    width: 11vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    transform: translateX(2.1vw);
    border-radius: 1vw;
  }
  &>p:nth-child(2){
    margin-left: 1vw;
  }  &>p {
       cursor: pointer;
       font-size: 1vw;
     }
  &>a{
    color: black;
    text-decoration: none;
    margin-left: .9vw;
  }
}
p {
  font-size: 1vw;
}
</style>